import type { App } from 'vue'

import { can } from '@/composables/usePermissions'

declare module 'vue' {
  interface ComponentCustomProperties {
    $can: (path: string) => boolean
  }
}

export const permissions = {
  install(app: App): void {
    app.provide('$can', can)
    app.config.globalProperties.$can = can
  },
}
